import React from 'react';

// Badges de servicios — ACERO & CRISTAL MTY
export const SERVICE_STYLES = {
  'Reemplazo de ventanas en general':               { background: '#dbeafe', color: '#1d4ed8' },
  'Sellado de ventanas':                            { background: '#cffafe', color: '#0e7490' },
  'Instalación de tragaluces':                      { background: '#fef3c7', color: '#b45309' },
  'Instalación de vidrios':                         { background: '#e0e7ff', color: '#4338ca' },
  'Instalación de ventanas':                        { background: '#dcfce7', color: '#15803d' },
  'Colocación de puertas en general':               { background: '#fce7f3', color: '#be185d' },
  'Reparación de tragaluces':                       { background: '#fef9c3', color: '#854d0e' },
  'Reparación de ventanas':                         { background: '#ffedd5', color: '#c2410c' },
  'Reparación de puertas en general':               { background: '#fee2e2', color: '#dc2626' },
  'Reparación y sustitución de marcos de ventanas': { background: '#ede9fe', color: '#7c3aed' }
};

export const SERVICIOS = Object.keys(SERVICE_STYLES);

export default function ServiceTag({ servicio }) {
  if (!servicio) return <span style={{ color: '#94a3b8' }}>—</span>;
  const match = Object.keys(SERVICE_STYLES).find(
    k => k.toLowerCase() === String(servicio).toLowerCase().trim()
  );
  const style = match ? SERVICE_STYLES[match] : { background: '#f1f5f9', color: '#475569' };
  return (
    <span style={{
      ...style,
      display: 'inline-block',
      padding: '3px 10px',
      borderRadius: 999,
      fontSize: 12,
      fontWeight: 600,
      whiteSpace: 'nowrap',
      maxWidth: 220,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      verticalAlign: 'middle'
    }} title={servicio}>
      {servicio}
    </span>
  );
}
